export const STUDY_RESTORATION_MODULE_NAME = 'Study Restoration';
export const INPUT_DATA_EXTRACTION_MODULE_NAME = 'Input Data Extraction';
